import React, { useContext, useEffect, useMemo, useState } from "react";
import PropTypes from "prop-types";
import useRegistrations from "../../hooks/useRegistrations";
import useCompanies from "../../hooks/useCompanies";
import useUsers from "../../hooks/useUsers";
import useAuth from "../../hooks/useAuth";
import InvitationStep1 from "./InvitationStep1";
import InvitationStep2 from "./InvitationStep2";
import AppContext from "../../AppContext";

const Invitation = ({ id, navigate }) => {
  const { confirmRegistration } = useRegistrations();
  const { createUser } = useUsers();
  const { signIn } = useAuth();
  const [registration, setRegistration] = useState();
  const { setToken } = useContext(AppContext);
  const [registrationStep, setRegistrationStep] = useState(1);
  const [createUserData, setCreateUserData] = useState({});

  useEffect(() => {
    fetchData();
    return () => {};
  }, [id]);

  const fetchData = async () => {
    try {
      const _registration = await confirmRegistration(id);
      if (!_registration?.company) {
        navigate("/");
        return;
      }
      setRegistration(_registration);
    } catch (error) {
      console.log(error);
      navigate("/");
    }
  };

  const step1Result = (data) => {
    setCreateUserData({ ...createUserData, ...data });
    setRegistrationStep(2);
  };

  const step2Result = async (data) => {
    //TODO Get plan
    const _createUserData = { ...createUserData, ...data };
    console.log("_createUserData", _createUserData);
    const { data: user } = await createUser(_createUserData, registration?._id);
    console.log("user", user);
    const token = await signIn(_createUserData.email, _createUserData.password);

    console.log("token", token);
    setToken(token);
    navigate("/");
    //TODO Goto login
  };

  if (registrationStep === 1)
    return (
      <InvitationStep1
        registrationId={registration?._id}
        companyId={registration?.company}
        step1Result={step1Result}
      />
    );

  if (registrationStep === 2)
    return <InvitationStep2 step2Result={step2Result} />;
};

Invitation.propTypes = {
  id: PropTypes.string.isRequired,
  navigate: PropTypes.func,
};

Invitation.defaultProps = {
  navigate: () => {},
};

export default Invitation;
